module.exports = __webpack_public_path__ + "img/wish.0d4c0e9a.webp";